import { render, staticRenderFns } from "./AbkListOfStudents.vue?vue&type=template&id=204d496a&scoped=true&"
import script from "./AbkListOfStudents.vue?vue&type=script&lang=js&"
export * from "./AbkListOfStudents.vue?vue&type=script&lang=js&"
import style0 from "./AbkListOfStudents.vue?vue&type=style&index=0&id=204d496a&lang=scss&scoped=true&"
import style1 from "./AbkListOfStudents.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d496a",
  null
  
)

export default component.exports